import { Partner } from "@hagerty/self-service-components/types/providerResponses/shared";

/* Determines if user is a State Farm partner */
export const isStateFarmPartner = (partner?: Partner): boolean => {
  return partner ? partner === "state-farm" : false;
};
